import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { FinancialPlanRefdataInterface } from '../request/interfaces/financialplan-refdata.interface';
import { TargetInterface } from '../../publicplanner/request/interfaces/target.interface';
import { SimulationTargetGrowInterface } from '../request/interfaces/simulation-taget-grow.interface';
import { SimulationRetirementInterface } from '../request/interfaces/simulation-retirement.interface';
import { SimulationObjInterface } from '../request/interfaces/simulation-obj.interface';
import { EvalGoalInterface } from '../request/interfaces/eval-goal.interface';
import { PortfolioInterface } from '../../profileportfolio/request/interfaces/portfolio.interface';
import { PublicPlannerEnum } from '../../../services/api-names';
import { Utils } from '../../../utils/utils';
import { SessionService } from '../../../services/session.service';
import { FeeInterface } from '../request/interfaces/fee.interface';

@Injectable({
  providedIn: 'root',
})
export class FinancialPlanningService {
  public fpReferenceDataSource =
    new BehaviorSubject<FinancialPlanRefdataInterface>({} as any); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  public fpReferenceData$ = this.fpReferenceDataSource.asObservable();
  public targetSelectSource = new BehaviorSubject<TargetInterface>({} as any); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  public targetSelect$ = this.targetSelectSource.asObservable();
  public stepSource = new BehaviorSubject<number>(0);
  public step$ = this.stepSource.asObservable();
  public step1Source = new BehaviorSubject<boolean>(true);
  public step1$ = this.step1Source.asObservable();
  public step2Source = new BehaviorSubject<boolean>(false);
  public step2$ = this.step2Source.asObservable();
  public step3Source = new BehaviorSubject<boolean>(false);
  public step3$ = this.step3Source.asObservable();
  public step4Source = new BehaviorSubject<boolean>(false);
  public step4$ = this.step4Source.asObservable();
  public step5Source = new BehaviorSubject<boolean>(false);
  public step5$ = this.step5Source.asObservable();
  public step6Source = new BehaviorSubject<boolean>(false);
  public step6$ = this.step6Source.asObservable();
  public gonextSource = new BehaviorSubject<boolean>(false);
  public gonext$ = this.gonextSource.asObservable();
  public simulationTagetGrowObj: SimulationTargetGrowInterface = {};
  public simulationRetirementObj: SimulationRetirementInterface = {};
  public simulationObj: SimulationObjInterface = {};
  public simulationObjSource = new BehaviorSubject<SimulationObjInterface>(
    {} as any
  ); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  public simulationObj$ = this.simulationObjSource.asObservable();
  public evalGoalObjSource = new BehaviorSubject<EvalGoalInterface>({} as any); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  public evalGoalObj$ = this.evalGoalObjSource.asObservable();
  public profileAnalysisSource = new BehaviorSubject<PortfolioInterface>(
    {} as any
  ); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  public profileAnalysis$ = this.profileAnalysisSource.asObservable();

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private http: HttpClient
  ) {}

  public getFinancialPlanRefData() {
    var url = this.config.baseApi + PublicPlannerEnum.apirest_eval_refdata;

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getEvalGoal(target: TargetInterface, obj: SimulationObjInterface) {
    var url = this.config.baseApi + PublicPlannerEnum.apirest_eval;

    let bodyRequest;
    switch (target.ServiceModelCode) {
      case 'H':
      case 'AP':
        bodyRequest = {
          Currency: obj.Currency,
          ProfileId: obj.ProfileId,
          GoalAmount: obj.GoalAmount,
          TimeHorizon: obj.TimeHorizon,
          InitialContributionAmount: obj.InitialContributionAmount,
          PeriodicContributionAmount: obj.PeriodicContributionAmount,
          PeriodicContributionFrequency: obj.PeriodicContributionFrequency,
          Priority: obj.Priority,
          InitialDate: obj.InitialDate,
          Type: target.Type,
          Name: target.Name,
        };
        break;
      case 'J':
        bodyRequest = {
          Currency: obj.Currency,
          ProfileId: obj.ProfileId,
          TimeHorizon: obj.TimeHorizon,
          InitialContributionAmount: obj.InitialContributionAmount,
          PeriodicContributionAmount: obj.PeriodicContributionAmount,
          PeriodicContributionFrequency: obj.PeriodicContributionFrequency,
          WithdrawlTimeHorizon: obj.WithdrawlTimeHorizon,
          AnnualIncomes: obj.AnnualIncomes,
          LivingStandards: obj.LivingStandards,
          SocialSecurityIncomePerc: obj.SocialSecurityIncomePerc,
          Priority: obj.Priority,
          InitialDate: obj.InitialDate,
          Type: target.Type,
          Name: target.Name,
        };
        break;
      default:
        break;
    }
    bodyRequest = JSON.stringify(bodyRequest);
    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getFees() {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_fees,
      [
        this.targetSelectSource.getValue().Type,
        this.simulationObjSource.getValue().ProfileId.toString(),
      ]
    );

    return this.http.get<FeeInterface>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getRiskprofile() {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_riskprofile,
      [this.targetSelectSource.getValue().Type]
    );

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getProfileAnalysis() {
    const amount =
      this.simulationObjSource.getValue().GoalAmount == null
        ? 0
        : this.simulationObjSource.getValue().GoalAmount;
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_profile_analysis,
      [
        this.targetSelectSource.getValue().Type,
        this.simulationObjSource.getValue().ProfileId.toString(),
        amount.toString(),
      ]
    );

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public saveGoal(goal: SimulationObjInterface) {
    let url = this.config.baseApi + PublicPlannerEnum.apirest_goal;
    let bodyRequest = JSON.stringify(goal);

    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public saveGoalPortfolio(goalId: string, portfolioCode: string) {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_goal_portfolio,
      [goalId]
    );

    //let bodyRequest = { PortfolioCodes: [portfolioCode] };
    let bodyRequest = [portfolioCode];

    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public funding(portfolioCode: string) {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_funding,
      [portfolioCode]
    );

    let bodyRequest = {
      Amount: this.simulationObjSource.getValue().InitialContributionAmount,
      Currency: this.simulationObjSource.getValue().Currency,
      FundTransfers: [],
      ModelPortfolioCode:
        this.evalGoalObjSource.getValue().model_portfolio_code,
    };

    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        //this.commonService.errorManager('getPortfolios', err);
        return throwError(err);
      })
    );
  }
}
